<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="耳标号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="tagsNumber">
              <a-input-number v-model="model.tagsNumber" placeholder="请输入耳标号" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="毛色" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="coatColor">
              <a-input v-model="model.coatColor" placeholder="请输入毛色"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="生日" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="birthday">
              <j-date placeholder="请选择生日" v-model="model.birthday" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="根据生日计算" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="monthOld">
              <a-input v-model="model.monthOld" placeholder="请输入根据生日计算"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="品种" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="varietyName">
              <j-dict-select-tag type="list" v-model="model.varietyName" dictCode="varieties_types"
                                 placeholder="请选择品种"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="当前状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="statusing">
              <j-dict-select-tag type="radio" v-model="model.statusing" dictCode="beef_status" placeholder="请选择当前状态"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="产犊数" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="calvingNumber">
              <a-input-number v-model="model.calvingNumber" placeholder="请输入产犊数" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="牛照片" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="photos">
              <j-image-upload isMultiple v-model="model.photos"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="牛类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="types">
              <j-dict-select-tag type="radio" v-model="model.types" dictCode="beef_types" placeholder="请选择牛类型"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.types=='0'">
            <a-form-model-item label="母牛耳标" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="types">
              <a-input v-model="model.beefNumber" placeholder="请输入母牛耳标"></a-input>
            </a-form-model-item>
          </a-col>
          <!--          <a-col :span="24" v-if="model.types=='0'">-->
          <!--            <a-form-model-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="gender">-->
          <!--              <j-dict-select-tag type="radio" v-model="model.gender" dictCode="beef_gender" placeholder="请选择性别"/>-->
          <!--            </a-form-model-item>-->
          <!--          </a-col>-->
          <a-col :span="24">
            <a-form-model-item label="所属养殖户" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userId">
              <!--              <j-dict-select-tag type="list" v-model="model.userId" dictCode="sys_user,realname,id,user_types=4" placeholder="请选择所属养殖户"/>-->
              <j-select-multi-user :multiple="false" v-model="model.userId"
                                   :url="{list:'/sys/user/list2'}"></j-select-multi-user>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'BeefCattleForm',
    components: {},
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          tagsNumber: [{ required: true, message: '请输入耳标号' }],
          birthday: [{ required: true, message: '请选择生日' }],
          statusing: [{ required: true, message: '请选择状态' }],
          types: [{ required: true, message: '请选择牛类型' }],
          userId: [{ required: true, message: '请选择养殖户' }]
        },
        url: {
          add: '/beef/beefCattle/add',
          edit: '/beef/beefCattle/edit',
          queryById: '/beef/beefCattle/queryById'
        }
      }
    },
    computed: {
      formDisabled() {
        return this.disabled
      }
    },
    created() {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
    },
    methods: {
      add() {
        this.edit(this.modelDefault)
      },
      edit(record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm() {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }

        })
      }
    }
  }
</script>